var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
export var ProgressContext = createContext({});
export function ProgressProvider(_a) {
    var children = _a.children, phases = _a.phases;
    var _b = useState(0), phase = _b[0], setPhase = _b[1];
    var _c = useState(0), step = _c[0], setStep = _c[1];
    return (_jsx(ProgressContext.Provider, __assign({ value: { phase: phase, setPhase: setPhase, step: step, setStep: setStep, phases: phases } }, { children: children })));
}
export default ProgressProvider;
